var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-yoga-layout",
    {
      attrs: {
        "width-auto": "1",
        "height-auto": "1",
        padding: "0",
        "flex-direction": "row",
        "yoga-layout-item": "",
        geometry: "primitive: plane;",
        material: "visible: false",
      },
    },
    [
      _c("a-image", {
        attrs: {
          src: _vm.block.field_values.image.url,
          width: _vm.imageWidth,
          height: _vm.imageHeight,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }